import AppTheme from "../../../AppTheme";
import * as TransactionMap from "../../constants/TransactionStatusMap"

export function getTransactionStatusText(transaction: any) {
    if (transaction['type'] == 2) {
        if (transaction['serviceName'] == 'Remote Consultation') {
            return 'E-Consult';
        } else if (transaction['serviceName'] == 'Followup') 
            return 'Follow-Up';
        else return "Aayu Card Subscription" 
    }
    else return TransactionMap.transactionStatusText[transaction['type']];
}

export function getTransactionStatusColor(transaction: any) {
    const additionsTtype = [3, 13, 14, 15, 16];
    const subtractionType = [2, 17];

    if (additionsTtype.includes(transaction['type'])) {
        return AppTheme.color.green.primary;
    } else if (subtractionType.includes(transaction['type'])) {
        return AppTheme.color.grey.text;
    } else return AppTheme.color.green.primary;
}

export function getTransactionSign(transaction: any) {
    const additionsType = [3, 5, 13, 14, 15, 16, 20];
    const subtractionType = [2, 17];

    if (transaction['amount'] == 0) {
        return "";
    } else if (additionsType.includes(transaction['type'])) {
        return '+';
    } else if (subtractionType.includes(transaction['type'])) {
        return '-';
    } else return "";
}